import React from 'react';
import {FormikErrors, withFormik} from 'formik';
import PropTypes from 'prop-types';
import {AddressServiceRequest} from 'commons/models';
import {InferPropTypes} from 'commons/types/Types';
import {FieldShape} from 'commons/shapes';
import {formValidator} from 'commons/utils/Functions';
import InnerFormRealOwnerLocationInfo from './InnerFormRealOwnerLocationInfo';
import {CONSTANT_VALUES} from 'commons/constants';

RealOwnerLocationInfoForm.propTypes = {
    viewId: PropTypes.number.isRequired,
    viewKey: PropTypes.string.isRequired,
    fieldHandler: PropTypes.func.isRequired,
    submitHandler: PropTypes.func.isRequired,
    foreignCitizen: PropTypes.bool.isRequired,
    fields: PropTypes.arrayOf(PropTypes.shape(FieldShape).isRequired).isRequired,
    auxRealownerInfo: PropTypes.any,
};

const FormControl = withFormik<
    InferPropTypes<typeof RealOwnerLocationInfoForm.propTypes>,
    AddressServiceRequest
>({
    mapPropsToErrors: () => {
        return {
            expedientId: '',
            workflowId: '',
            viewId: '',
            viewFatherId: '',
            kycId: '',
            addressId: '',
            streetDescription: '',
            addressDescription: '',
            outdoorNumber: '',
            interiorNumber: '',
            zipCode: '',
            colonyKey: '',
            colonyDescription: '',
            municipalityKey: '',
            municipalityDescription: '',
            stateKey: '',
            stateDescription: '',
            countryKey: '',
            hasNext: '',
        };
    },
    mapPropsToValues: (props) => {
        const {auxRealownerInfo} = props;
        if (auxRealownerInfo) {
            return {
                expedientId: auxRealownerInfo.expedientId || 0,
                workflowId: auxRealownerInfo.workflowId || 0,
                viewId: auxRealownerInfo.viewId || 0,
                viewFatherId: auxRealownerInfo.viewFatherId || 0,
                kycId: auxRealownerInfo.kycId || 0,
                addressId: auxRealownerInfo.addressId || 1,
                streetDescription: auxRealownerInfo.streetDescription || '',
                addressDescription: auxRealownerInfo.addressDescription || '',
                outdoorNumber: auxRealownerInfo.outdoorNumber || '',
                interiorNumber: auxRealownerInfo.interiorNumber || '',
                zipCode: auxRealownerInfo.zipCode || '',
                colonyKey: auxRealownerInfo.colonyKey || '',
                colonyDescription: auxRealownerInfo.colonyDescription || '',
                municipalityKey: auxRealownerInfo.municipalityKey || '',
                municipalityDescription: auxRealownerInfo.municipalityDescription || '',
                stateKey: auxRealownerInfo.stateKey || '',
                stateDescription: auxRealownerInfo.stateDescription || '',
                countryKey: auxRealownerInfo.countryKey || '',
                hasNext: auxRealownerInfo.hasNext || false,
            };
        } else {
            return {
                expedientId: 0,
                workflowId: 0,
                viewId: 0,
                viewFatherId: 0,
                kycId: 0,
                addressId: null,
                streetDescription: '',
                addressDescription: '',
                outdoorNumber: '',
                interiorNumber: '',
                zipCode: '',
                colonyKey: '',
                colonyDescription: '',
                municipalityKey: '',
                municipalityDescription: '',
                stateKey: '',
                stateDescription: '',
                countryKey: props.foreignCitizen ? '' : CONSTANT_VALUES.MexicoId,
                hasNext: false,
            };
        }
    },
    validateOnBlur: true,
    validateOnChange: true,
    validate: (values: AddressServiceRequest, props) => {
        const errors: FormikErrors<AddressServiceRequest> = {};
        formValidator(props.fields, errors, values);
        return errors;
    },
    handleSubmit: (values, actions) => {
        actions.setSubmitting(false);
        actions.props.submitHandler({...values});
    },
})(InnerFormRealOwnerLocationInfo);

function RealOwnerLocationInfoForm(
    props: InferPropTypes<typeof RealOwnerLocationInfoForm.propTypes>
) {
    const {submitHandler, fields, viewId, auxRealownerInfo, fieldHandler, foreignCitizen, viewKey} =
        props;

    /* eslint-disable react/jsx-handler-names */
    return (
        <FormControl
            viewId={viewId}
            fields={fields}
            foreignCitizen={foreignCitizen}
            fieldHandler={fieldHandler}
            viewKey={viewKey}
            submitHandler={submitHandler}
            auxRealownerInfo={auxRealownerInfo}
        />
    );
}

export default RealOwnerLocationInfoForm;
